export default "__VITE_ASSET__UPPCD_Xg__"